import { Action } from 'redux'
import { NotificationActions } from '../../reducers/userAccount/actionNames'

const notificationErrorMessageSendend = (
  id: string,
): INotificationErrorSended => ({
  id,
  type: NotificationActions.ErrorSended,
})

export interface INotificationErrorSended
  extends Action<NotificationActions.ErrorSended> {
  id: string
}

export default notificationErrorMessageSendend
